import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { provideIntlService } from '@progress/kendo-react-intl';
import { addDonations, getDonationTypes, updatePayment, clearAlerts, fetchMembershipTypes, fetchMembershipPackages }
    from "../../../../../Redux/Actions/EndUser/MembershipAction";
import { clearPayment } from "../../../../../Redux/Actions/EndUser/AccountDetailsActions";
import { NumericTextBox } from '@progress/kendo-react-inputs';
import CardPayment from './CardPayment';
import Modal from 'react-modal';
import { Input } from 'reactstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import SpanSpinner from '../../../../Shared/SpanSpinner/SpanSpinner';
import { Alert } from 'reactstrap';
import './PaymentDetails.scss'

class PaymentDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentInEdit: {
                membershipId: props.membershipId,
                cardInfo: {},
                autoRenew: false,
                payDues: false,
                updateCard: false //Added changes wrt TM-93: Member selects "Update my Credit Card" should get card details to edit information
            },
            dataHasLoaded: false,

            alertVisible: false,
            alertColor: "",
            alertMessage: "",
            membershipPackage: {},
            membershipType: {},
            donations: [],
            initialAutoRenew: false,
        };
        this.formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }

    componentDidMount() {
        this.props.fetchMembershipTypes();
        this.props.fetchMembershipPackages(this.props.membership.membershipTypeObject.membershipTypeID);

        const newState = Object.assign({}, this.state);
        newState.membershipTypeObject = this.props.membership.membershipTypeObject;
        newState.membershipPackageObject = this.props.membership.membershipPackageObject;
        newState.initialAutoRenew = this.props.membership.isAutoRenew;
        this.setState(
            newState
        );

        //If we haven't loaded the donation types yet
        if (!this.props.donations) {
            this.props.getDonationTypes();
        }
        else {

            this.initializeDonations();
        }
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.paymentMethod == null && this.props.paymentMethod != null && !this.state.dataHasLoaded) {
            var results = this.updatePaymentData(this.props.paymentMethod);
            this.setState({
                dataHasLoaded: true,
                paymentInEdit: results,
                alertVisible: false
            });
        }

        if (prevState.alertVisible != this.props.alertVisible) {
            this.setState({
                alertVisible: this.props.alertVisible,
                alertColor: this.props.alertColor,
                alertMessage: this.props.alertMessage
            });
        }

        if (prevProps.membershipPackages != this.props.membershipPackages && this.props.membershipPackages.length > 0) {
            //console.log("we got new packages!", this.props.membershipPackages);

            //this.setState({
            //    membershipPackageObject: this.props.membershipPackages[0]
            //});

        }

        if (prevProps.donations !== this.props.donations) {
            this.initializeDonations();
        }
    }

    initializeDonations = () => {
        let donationsForDisplay = [...this.props.donations];

        // Get only donations that should appear on addons
        donationsForDisplay = donationsForDisplay.filter(donation => donation.isAddon);
        let total = 0;

        donationsForDisplay.map(donation => {
            donation.amount = 0;
        });

        this.setState({
            donations: donationsForDisplay
        });
    }

    handleDonationChange = (event) => {
        let editedDonations = [...this.state.donations];
        let index = editedDonations.findIndex(el => {
            return el.name == event.target.name
        });

        editedDonations[index].amount = event.target.value;

        this.setState({
            donations: editedDonations,
        });
    }

    handleMembershipTypeChange = (event) => {
        var value = event.target.value;

        if (value !== null) {
            const newState = Object.assign({}, this.state);
            newState.membershipTypeObject = value;
            newState.membershipPackageObject = {};
            this.setState(
                newState
            );
            this.props.fetchMembershipPackages(value.membershipTypeID);
        }
    }

    handlePackageChange = (event) => {
        const newState = Object.assign({}, this.state);
        newState.membershipPackageObject = event.target.value;
        this.setState(newState);
    }

    updatePaymentData = (data) => {
        var card;
        if (data.cardDetailsViewModel != null) {
            card = {
                NameOnCard: data.cardDetailsViewModel.nameOnCard,
                CardNumber: data.cardDetailsViewModel.cardNumber,
                CardExpMonth: data.cardDetailsViewModel.cardExpMonth,
                CardExpYear: data.cardDetailsViewModel.cardExpYear,
                CardCVC: data.cardDetailsViewModel.cardCVC
            };
        } else {
            card = {
                NameOnCard: "",
                CardNumber: "",
                CardExpMonth: "",
                CardExpYear: "",
                CardCVC: ""
            };
        }

        return {
            autoRenew: data.isAutoRenew,
            payDues: !data.isAutoRenew,
            cardInfo: card
        };
    }

    onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state.paymentInEdit;
        edited[name] = value;
        this.setState({
            paymentInEdit: edited,
            isActive: true
        });
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({
            alertVisible: false,
            alertMessage: "",
        });

        let donationModel = [];

        if (this.isModelValid()) {
            const paymentPost = {
                MembershipId: this.props.membershipId,
                IsAutoRenew: this.state.paymentInEdit.autoRenew,
                PayDues: this.state.paymentInEdit.payDues,
                UpdateCreditCard: this.state.paymentInEdit.updateCard,
                CardDetailsViewModel: {
                    ...this.state.paymentInEdit.cardInfo
                },
                MembershipType: this.state.membershipTypeObject,
                MembershipPackage: this.state.membershipPackageObject,
                DonationViewModel: this.state.donations.map((donation) => {
                    return ({
                        SuggestedCost: Number(donation.amount),
                        ActualCost: Number(donation.amount),
                        DonationTypeId: donation.id,
                        DonationType: donation.name
                    })
                }),
            }

            this.props.updatePayment(paymentPost);
        } else {
            this.setAllTouchedTrue();
        }
    }

    setAllTouchedTrue() {
        this.child.setAllTouchedTrue();
    }

    isModelValid() {
        var donations = this.state.donations && this.state.donations.length > 0;

        if (this.state.paymentInEdit.payDues || this.state.paymentInEdit.updateCard) {

            if (this.state.paymentInEdit.updateCard || this.state.paymentInEdit.payDues) {
                var nameOnCard = this.state.paymentInEdit.cardInfo.NameOnCard !== "";

                var cardNumber = this.state.paymentInEdit.cardInfo.CardNumber !== "" &&
                    this.state.paymentInEdit.cardInfo.CardNumber.indexOf('*') < 0;

                var cardExpMonth = this.state.paymentInEdit.cardInfo.CardExpMonth !== "";

                var cardExpYear = this.state.paymentInEdit.cardInfo.CardExpYear !== "";

                var cardCVC = this.state.paymentInEdit.cardInfo.CardCVC !== "" &&
                    this.state.paymentInEdit.cardInfo.CardCVC.indexOf('*') < 0;

                return nameOnCard && cardNumber && cardExpMonth && cardExpYear && cardCVC && donations;
            }
            else {
                return donations;
            }
        }
        else {
            return true;
        }
    }

    cardStateChange = (cardObj) => {
        const edited = this.state.paymentInEdit;
        edited.cardInfo = cardObj.cardInfo;
        this.setState({
            paymentInEdit: edited,
            isActive: cardObj.isActive
        });
    }

    handlePaymentTypeChange = (event) => {
        let target = event.target;
        const value = target.checked;  // Get the checked state (true/false)
        const name = target.name
        // Reset all checkboxes and enable only the selected one
        let updatedState = {
            payDues: false,
            updateCard: name === "payDues" ? value : this.state.paymentInEdit.updateCard
        };

        //Set the selected checkbox to true
        updatedState[name] = value;
        this.setState({
            paymentInEdit: { ...this.state.paymentInEdit, ...updatedState }
        });
    };

    handleAutoRenewCheckboxChange = (event) => {
        let target = event.target;
        const value = target.checked;  // Get the checked state (true/false)
        const name = target.name
        // Reset all checkboxes and enable only the selected one
        let updatedState = {
            autoRenew: false,
        };
        //Set the selected checkbox to true
        updatedState[name] = value;

        this.setState({
            paymentInEdit: { ...this.state.paymentInEdit, ...updatedState }
        });
    };

    handleUpdatePaymentMethodCheckboxChange = (event) => {
        let target = event.target;
        const value = target.checked;  // Get the checked state (true/false)
        const name = target.name
        // Reset checkbox and enable only the selected one
        let updatedState = {
            updateCard: false
        };

        //Set the selected checkbox to true
        updatedState[name] = value;
        this.setState({
            paymentInEdit: { ...this.state.paymentInEdit, ...updatedState }
        });

    };

    close = (event) => {
        this.props.clearPayment();
        this.props.clearAlerts();
        this.props.close();

        this.setState({ dataHasLoaded: false });
        // Trigger page reload immediately upon clicking Save
        window.location.reload();
    };

    getTotalTransactionAmount = () => {
        // Sum of all donation amounts
        const totalDonations = this.state.donations.reduce(
            (sum, donation) => sum + (donation.amount || 0),
            0
        );

        // Ensure membership cost is a valid number
        const membershipCost = Number(this.state.membershipPackageObject.cost) || 0;

        // Total sum (donations + membership cost)
        return totalDonations + membershipCost;
    };

    render() {
        //console.log(this.props.membershipTypes);

        return (
            <div className="payment-details">
                <Modal
                    isOpen={this.props.isPopupVisible}
                    onRequestClose={this.close}
                    ariaHideApp={false}
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            marginRight: '-50%',
                            minWidth: '50vw',
                            maxWidth: '50vw',
                            minHeight: '80vh',
                            maxHeight: '80vh',
                            overflow: 'auto',
                            transform: 'translate(-50%, -50%)',
                            borderRadius: '5px'
                        }
                    }}
                >
                    <Alert color={this.state.alertColor} isOpen={this.state.alertVisible} toggle={() => {
                        this.setState({ alertVisible: false, alertMessage: "" })
                    }}>{this.state.alertMessage ?? ""}</Alert>

                    {!this.state.alertVisible ?
                        <form className="payment-form d-flex flex-wrap" onSubmit={this.handleSubmit}>
                            {/*<div className="row membership-type-package">*/}
                            {/*    <div className="col-md-12">*/}
                            {/*        <h3>ACCOUNT STATUS:</h3>*/}
                            {/*    </div>*/}
                            {/*    <div className="col-md-12">*/}
                            {/*        {this.state.initialAutoRenew ?*/}
                            {/*            <p> Your current Membership Type is {this.props.membership != null ?*/}
                            {/*                <strong>{this.props.membership.membershipType}</strong>*/}
                            {/*                : null} and the Membership Package is <strong>{this.props.membership.membershipPackage}</strong>.*/}
                            {/*                This is paid through {(() => {*/}
                            {/*                    const nextRenewDate = new Date(this.props.membership.nextRenewDate);*/}
                            {/*                    const prevRenewDate = new Date(nextRenewDate);*/}
                            {/*                    prevRenewDate.setDate(prevRenewDate.getDate() - 1); // Subtract 1 day*/}
                            {/*                    return provideIntlService(this).formatDate(prevRenewDate, 'MM/d/y');*/}
                            {/*                })()}.*/}
                            {/*                This will renew automatically on {provideIntlService(this).formatDate(new Date(this.props.membership.nextRenewDate), 'MM/d/y')} with the card that is saved on file.*/}
                            {/*            </p>*/}
                            {/*            : <p> Your prior Membership of Type {this.props.membership != null ?*/}
                            {/*                <strong>{this.props.membership.membershipType} </strong>*/}
                            {/*                : null} and package of <strong>{this.props.membership.membershipPackage} </strong>*/}
                            {/*                expired on {provideIntlService(this).formatDate(new Date(this.props.membership.nextRenewDate), 'MM/d/y')}.*/}
                            {/*            </p>*/}
                            {/*        }*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            <div className="row membership-type-package">
                                <div className="col-md-12">
                                    <h3>MEMBERSHIP TYPE & PACKAGE:</h3>
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="membershipType">Membership Type</label>
                                    <DropDownList data={this.props.membershipTypes?.filter((type) => (type.description.toUpperCase() != 'TSCRA_VERIFY'))}
                                        textField="description"
                                        dataItemKey="membershipTypeID"
                                        onChange={this.handleMembershipTypeChange}
                                        value={this.state.membershipTypeObject}
                                        width={300}
                                        required={true}
                                        valid={this.state.membershipTypeObject != null && Object.keys(this.state.membershipTypeObject).length > 0}
                                        name="membershipType"
                                        id="membershipType"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="membershipPackage">Membership Package</label>
                                    <DropDownList data={this.props.membershipPackages}
                                        textField="description"
                                        dataItemKey="membershipPackageID"
                                        onChange={this.handlePackageChange}
                                        value={this.state.membershipPackageObject}
                                        width={300}
                                        required={true}
                                        valid={this.state.membershipPackageObject != null && Object.keys(this.state.membershipPackageObject).length > 0}
                                        name="membershipPackage"
                                        id="membershipPackage"
                                    />
                                </div>
                                <div className="cost col-md-12">
                                    {this.state.membershipPackageObject != null ?
                                        <p>Membership Cost: {this.formatter.format(this.state.membershipPackageObject.cost)}</p>
                                        : null}
                                </div>
                                {/*<div className="cost col-md-12">*/}

                                {/*    {this.state.paymentInEdit.autoRenew ?*/}
                                {/*        <p> The selections above will be applied and membership will renew automatically on  {this.props.membership != null ?*/}
                                {/*            provideIntlService(this).formatDate(new Date(this.props.membership.nextRenewDate), 'MM/d/y')*/}
                                {/*            : null}. On that date, a charge of <strong>{this.formatter.format(this.state.membershipPackageObject.cost)}</strong> will be made to the card on file.</p>*/}
                                {/*        :*/}
                                {/*        this.state.membershipPackageObject != null ?*/}
                                {/*            <p> The selections above will be applied and membership will renew today. A charge of  {this.formatter.format(this.state.membershipPackageObject.cost)} will be made to the card on file.</p>*/}
                                {/*            : null*/}

                                {/*    }*/}

                                {/*</div>*/}
                            </div>

                            <div className="row payment-options">
                                <div className="col-md-12">
                                    <h3>Payment Options</h3>
                                </div>
                            </div>

                            <div className="subscription-details">

                                <div className="list-group-item form-group">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            name="autoRenew"
                                            id="autoRenew"
                                            type="checkbox"
                                            className="custom-control-input"
                                            onChange={this.handleAutoRenewCheckboxChange}
                                            checked={this.state.paymentInEdit.autoRenew}
                                        />
                                        <label className="custom-control-label" htmlFor="autoRenew">Auto-Renew Membership</label>
                                    </div>
                                    <p><strong>Next Renewal Date:</strong> {provideIntlService(this).formatDate(new Date(this.props.membership.nextRenewDate), 'MM/d/y')}</p>
                                    <p>When your membership is up for renewal, this credit card will be charged automatically. You won't have to do anything.</p>
                                </div>

                                <div className="list-group-item form-group">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            name="payDues"
                                            id="payDues"
                                            type="checkbox"
                                            className="custom-control-input"
                                            checked={this.state.paymentInEdit.payDues}
                                            onChange={this.handlePaymentTypeChange}
                                        />
                                        <label className="custom-control-label" htmlFor="payDues">Pay Dues</label>
                                    </div>
                                    <p>Your membership will be good for 1 year. You will receive an email to remind you that your membership is expiring, 30 days from expiring. Paying dues now will extend your membership an additional year.</p>
                                    {this.state.paymentInEdit.payDues ?
                                        <p>By checking the PAY DUES box, you have chosen to pay your Membership dues of {this.state.membershipPackageObject != null ?
                                            this.formatter.format(this.state.membershipPackageObject.cost)
                                            : null} today.</p>
                                        : <p>If you check the PAY DUES box, you can pay your Membership dues of {this.state.membershipPackageObject != null ?
                                            this.formatter.format(this.state.membershipPackageObject.cost)
                                            : null} today.</p>
                                    }
                                </div>
                            </div>
                            <div className="row donation">
                                <div className="donationTitle col-md-12">
                                    <h3>MAKE DONATIONS:</h3>
                                </div>

                                <div className="col-md-12">
                                    <p className="subHeading">Your contributions are very important to the success of our organization. Please consider making an additional donation to help us achieve our collective goals.</p>
                                </div>
                                {
                                    this.state.donations ? this.state.donations.map((donation, i) => {
                                        return (
                                            <div className="donationItem row" key={`donations-${i}`}>
                                                <div className="col-md-12">
                                                    <label>{donation.name}</label>
                                                    <NumericTextBox
                                                        defaultValue={donation.amount}
                                                        format="c2"
                                                        min={0}
                                                        onChange={this.handleDonationChange}
                                                        name={donation.name}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                        :
                                        ''
                                }
                            </div>
                            
                            {/* ✅ Added New checkbox for Update My Credit Card WRT TM-93*/}
                            <div className="subscription-details">
                                <div className="list-group-item form-group">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            name="updateCard"
                                            id="updateCard"
                                            type="checkbox"
                                            className="custom-control-input"
                                            checked={this.state.paymentInEdit.updateCard || this.state.paymentInEdit.payDues}
                                            onChange={this.handleUpdatePaymentMethodCheckboxChange}
                                            disabled={this.state.paymentInEdit.payDues ? true : false}
                                        />
                                        <label className="custom-control-label" htmlFor="updateCard">Update My Credit Card</label>
                                    </div>
                                    <p>Update your credit card information on file.</p>
                                    {this.state.paymentInEdit.updateCard ?
                                        <p> The Card information entered below will be saved to file and used for all future renewals.</p>
                                        : null
                                    }
                                </div>
                                {this.state.paymentInEdit.payDues || this.state.paymentInEdit.updateCard ?
                                <CardPayment
                                    cardStateChange={this.cardStateChange}
                                    paymentMethod={this.state.paymentInEdit.cardInfo}
                                    onRef={ref => (this.child = ref)} />
                                : null}
                            </div>
                            <div className="totalTransactionText col-md-12">
                                {this.state.paymentInEdit.payDues ?
                                    <p><strong>{this.formatter.format(this.getTotalTransactionAmount().toFixed(2))}</strong> will be charged to your card when you click SAVE.</p>
                                    : <p>No charges will be made to your card.</p>}
                            </div>
                            <div className="button-group d-flex flex-wrap">
                                <div className="col-sm-3">
                                    <button
                                        className="btn-save btnPrimary btn btn-primary"
                                        type="submit"
                                        disabled={this.props.updating}
                                    >
                                        {
                                            this.props.updating ?
                                                <SpanSpinner message="Saving ..." />
                                                : <span>Save</span>
                                        }
                                    </button>
                                </div>
                            </div>
                        </form>
                        : null
                    }
                    <div className="col-sm-3">
                        <button className="btn-cancel btnSecondary btn" type="button" onClick={() => this.close()} disabled={this.props.updating}>Close</button>
                    </div>
                </Modal>
            </div>
        );
    }
};

function mapStateToProps(state) {
    return {
        membership: state.accountDetails.selectedMember,
        updating: state.membership.updatingPayment,
        alertMessage: state.membership.alertMessage,
        alertColor: state.membership.alertColor,
        alertVisible: state.membership.alertVisible,

        membershipTypes: state.membership.membershipTypes,
        membershipPackages: state.membership.membershipPackages,
        donations: state.membership.allDonationOptions
    };
}

export default withRouter(connect(mapStateToProps, {
    addDonations,
    getDonationTypes,
    updatePayment,
    clearAlerts,
    clearPayment,
    fetchMembershipTypes,
    fetchMembershipPackages
})(PaymentDetails));
